import { createSlice } from "@reduxjs/toolkit";

const verifySlice = createSlice({
  name: "verify",
  initialState: { username: null, type: null },
  reducers: {
    setCurrentUserName: (state, action) => {
      const { username } = action.payload;
      state.username = username;
    },
    unSetCurrentUserName: (state, action) => {
      state.username = null;
    },
  },
});

export const { setCurrentUserName, unSetCurrentUserName } = verifySlice.actions;

export default verifySlice.reducer;

export const selectCurrentUserName = (state) => state.verify.username;
